import { getSavedAuthSession } from "../utils/authStorage";
import { API_ERROR_MESSAGES } from "../constants/api";
import { buildApiUrl } from "./apiConfig";
import { ensureValidAccessToken, refreshAuthSession } from "./authSession";

export function buildAuthHeaders(headersInit, authToken) {
  const headers = new Headers(headersInit || {});
  const token = authToken;
  const userHeaders = buildCurrentUserHeaders();

  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  if (userHeaders["x-username"] && !headers.has("x-username")) {
    headers.set("x-username", userHeaders["x-username"]);
  }

  return headers;
}

export async function apiFetch(path, options = {}) {
  const { authToken, headers, skipAuth = false, ...fetchOptions } = options;
  const url = path.startsWith("http") ? path : buildApiUrl(path);
  const token = skipAuth ? null : authToken || (await ensureValidAccessToken());

  let response = await fetch(url, {
    ...fetchOptions,
    headers: skipAuth ? headers : buildAuthHeaders(headers, token),
  });

  if (response.status === 401 && !skipAuth && !authToken) {
    const refreshedSession = await refreshAuthSession({ force: true });
    response = await fetch(url, {
      ...fetchOptions,
      headers: buildAuthHeaders(headers, refreshedSession.accessToken),
    });
  }

  return response;
}

export function buildCurrentUserHeaders({ includeRole = false } = {}) {
  const session = getSavedAuthSession();
  const headers = {};

  if (session?.user?.username) {
    headers["x-username"] = session.user.username;
  }

  if (session?.user?.id !== undefined && session?.user?.id !== null) {
    headers["x-user-id"] = String(session.user.id);
  }

  if (includeRole && session?.user?.role) {
    headers["x-role"] = session.user.role;
  }

  return headers;
}

export function getRequiredUsernameHeader() {
  const headers = buildCurrentUserHeaders();

  if (!headers["x-username"]) {
    throw new Error(API_ERROR_MESSAGES.authenticatedUsernameMissing);
  }

  return headers;
}

export function getRequiredCurrentUserHeaders(options) {
  const headers = buildCurrentUserHeaders(options);

  if (!headers["x-username"]) {
    throw new Error(API_ERROR_MESSAGES.authenticatedUsernameMissing);
  }

  return headers;
}
